export default __webpack_public_path__ + "static/media/photo--lg--ayaka2.7ae5266a.jpg";